import * as types from './types';
import * as constants from './constants'

export default {

    [types.MUTATE_TOTAL_ROWS]: (state, payload) => {
        state.totalRows = payload
    },
    [types.MUTATE_NOTIFICATION_ID]: (state, payload) => {
        state.notificationId = payload
    },
    [types.MUTATE_ORG_ANONYMOUS]: (state, payload) => {
        state.isOrgAnonymous = payload
    },
    [types.MUTATE_SUBMITTED_ID]: (state, payload) => {
        state.submittedId = payload
    },
    [types.MUTATE_PURPOSE_ID]: (state, payload) => {
        state.purposeId = payload;
    },
    [types.MUTATE_PURPOSE_OTHERS]: (state, payload) => {
        state.purposeOthers = payload;
    },
    [types.MUTATE_DETAILS_NOTIFICATION]: (state, payload) => {
        state.detailsNotification = payload;
    },
    [types.MUTATE_REQUEST_TYPE_ID]: (state, payload) => {        
        state.requestTypeId = payload;
    },
    [types.MUTATE_REQUESTED_DATE]: (state, payload) => {        
        state.request_date = payload;
    },
    [types.MUTATE_MAP]: (state, payload) => {
        state.map = payload;        
    },
    [types.MUTATE_WAYPOINTS]: (state, payload) => {
        state.waypoints = payload;
    },
    [types.MUTATE_PURPOSES]: (state, payload) => {
        state.purposeList = payload;
    },
    [types.MUTATE_AGENCIES]: (state, payload) => {
        state.agencyList = payload;
    },
    [types.MUTATE_REQUEST_TYPES]: (state, payload) => {
        state.requestTypeList = payload;
    },
    [types.MUTATE_EMERGENCY_NOTIFICATION]: (state, payload) => {
        state.emergencyNotificationList = payload;
    },
    [types.MUTATE_STATUSES]: (state, payload) => {
        state.statusList = payload;
    },
    [types.MUTATE_AIR_USAGE]: (state, payload) => {
        state.usageList = payload;
    },
    [types.MUTATE_AIR_CLEARANCE]: (state, payload) => {
        state.clearanceList = payload;
    },
    [types.MUTATE_AIR_REQUEST]: (state, payload) => {
        state.requestList = payload;
    },
    [types.MUTATE_AIR_OPERATOR]: (state, payload) => {
        state.operatorList = payload;
    },
    [types.MUTATE_NSL_FACILITY_TYPE]: (state, payload) => {
        state.facilityTypeList = payload;
    },
    [types.MUTATE_NSL_SITE_TYPE]: (state, payload) => {
        state.siteTypeList = payload;
    },
    [types.MUTATE_ATTACHMENTS]: (state, payload) => {
        state.attachmentList = payload;
    },
    [types.MUTATE_USER_ID]: (state, payload) => {
        state.userId = payload;        
    },
    [types.MUTATE_USERNAME]: (state, payload) => {
        state.username = payload;        
    },
    [types.MUTATE_USER_FIRSTNAME]: (state, payload) => {
        state.firstname = payload;        
    },
    [types.MUTATE_USER_LASTNAME]: (state, payload) => {
        state.lastname = payload;        
    },
    [types.MUTATE_USER_TOKEN]: (state, payload) => {
        state.token = payload;        
    },
    [types.MUTATE_USER_PERMISSION]: (state, payload) => {
        state.permission = payload;        
    },
    [types.MUTATE_USER_AGENCY_ID]: (state, payload) => {
        state.agencyId = payload;        
    },
    [types.MUTATE_USER_AGENCY_NAME]: (state, payload) => {
        state.agencyName = payload;        
    },
    [types.MUTATE_REQUEST_TYPE_ID]: (state, payload) => {
        state.requestTypeId = payload;        
    },
    [types.MUTATE_EHOC_REF]: (state, payload) => {
        state.ehocRef = payload;        
    },
    [types.MUTATE_CENTCOM_REF]: (state, payload) => {
        state.centcomRef = payload;        
    },
    [types.MUTATE_NV_FOR]: (state, payload) => {
        state.nv_for = payload;        
    },
    [types.MUTATE_NV_NUMBER]: (state, payload) => {
        state.nv_number = payload;        
    },
    [types.MUTATE_REQUEST_TYPE_ID]: (state, payload) => {
        state.requestTypeId = payload;        
    },
    [types.MUTATE_REQUESTED_BY]: (state, payload) => {
        state.requestedBy = payload;        
    },
    [types.MUTATE_LAST_UPDATED_BY]: (state, payload) => {
        state.lastUpdatedBy = payload;        
    },
    [types.MUTATE_NOTES]: (state, payload) => {
        state.notes = payload;        
    },
    [types.MUTATE_STATUS_ID]: (state, payload) => {
        state.statusId = payload;        
    },
    [types.MUTATE_START_DATE]: (state, payload) => {
        state.start_date = payload;
    },
    // [types.MUTATE_DEPARTURE_DATE]: (state, payload) => {
    //     state.departure_date = payload;        
    // },
    // [types.MUTATE_ARRIVAL_DATE]: (state, payload) => {
    //     state.arrival_date = payload;        
    // },

    // [types.MUTATE_PHOTOS]: (state, payload) => {
    //     state.photos = payload;        
    // },
    [types.MUTATE_MODE]: (state, payload) => {
        state.mode = payload;        
    },
    [types.MUTATE_VIEW_MOFA]: (state, payload) => {
        state.viewMofa = payload;        
    },
    [types.MUTATE_MODIFIED]: (state, payload) => {
        state.modified = payload;        
    },
    [types.MUTATE_NEW_NOTIFICATION]: (state, payload) => {
        state.new_notification = payload;        
    },
    [types.MUTATE_MAP_MODIFIED]: (state, payload) => {
        state.map_modified = payload;        
    },
    [types.MUTATE_MAP_INDEX]: (state, payload) => {
        state.map_index = payload;        
    },
    [types.MUTATE_RESET_STATE]: (state, payload) => {
      const initial = constants.initialState()
          Object.keys(initial).forEach(key => {
            if ( key !== 'userId' && key !== 'token' && key !== 'permission' && 
                 key !== 'agencyId' && key !== 'statusList' && key !== 'agencyList' && key !== 'requestTypeList' &&
                 key !== 'facilityTypeList' && key !== 'siteTypeList' && key !== 'username' && key !== 'agencyName') {
                state[key] = initial[key] 
            }
          })  
      
      const initialLand = constants.initialStateLandMovement()
          Object.keys(initialLand).forEach(key => { 
                state.land_movement[key] = initialLand[key] 
          })

      const initialTemp = constants.initialStateTempVenue()
          Object.keys(initialTemp).forEach(key => { 
                state.venues = initialTemp[key] 
          })

      const initialSea = constants.initialStateSea()
          Object.keys(initialSea).forEach(key => { 
                state.sea[key] = initialSea[key]
          })

      const initialAir= constants.initialStateAir()
          Object.keys(initialAir).forEach(key => { 
                state.air[key] = initialAir[key]
          })    

      const initialMofa = constants.initialStateMofa()
          Object.keys(initialMofa).forEach(key => { 
                state.mofa[key] = initialMofa[key]
          })
      
      const initialNotification = constants.initialStateNotification() 
          Object.keys(initialNotification).forEach(key => {
                state.notification[key] = initialNotification[key] 
          })      
    },
    [types.MUTATE_RESET_TOKEN]: (state, payload) => {
        const initial = constants.initialState()
            Object.keys(initial).forEach(key => {
                if ( key === 'userId' || key === 'token' || key === 'permission') {
                     state[key] = initial[key]
                }
            })        
    },
}


// WEBPACK FOOTER //
// ./src/store/mutations.js